export const PRODUCTS = {
    "02": "Quamtra",
    "07": "ACTIS Plus Nema7",
    "08": "MiniQ",
    "09": "GWIRE",
    "10": "Ultralite",
    "11": "Ultralite Plus",
    "12": "GWIRE+",
    "13": "ACTIS Plus",
    "14": "MOOVIX",
    "15": "ACTIS Zhaga",
    "16": "MiniQ 2"
};